import { render, staticRenderFns } from "./AlertsChart.vue?vue&type=template&id=b25d09ba"
import script from "./AlertsChart.vue?vue&type=script&lang=js"
export * from "./AlertsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports